import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './ChargingPoint.scss';

const ChargingPoint = (props) => (
    <Icon iconName="ChargingPoint" {...props}>
        <svg viewBox="0 0 31.02 28.61" {...props}>
            <g>
                <path
                    strokeWidth={0}
                    // eslint-disable-next-line
                    d="M17.1 27.61h-2V3.86a1.08 1.08 0 00-1.08-1.08H5.23a1.08 1.08 0 00-1.08 1.08v23.75h-2V3.86A3.08 3.08 0 015.23.78h8.79a3.08 3.08 0 013.08 3.08z"
                />
                <path strokeWidth={0} fill="none" d="M1 27.61h17.25" />
                <path
                    strokeWidth={0}
                    // eslint-disable-next-line
                    d="M18.25 28.61H1a1 1 0 110-2h17.25a1 1 0 010 2zM8.62 12.91a1 1 0 01-.74-1.68L9.31 9.7 7.7 9.15a1 1 0 01-.38-1.66l2.54-2.54a1.004 1.004 0 011.42 1.42L9.87 7.78l1.54.53a1 1 0 01.65.7 1 1 0 01-.24.93l-2.47 2.65a1 1 0 01-.73.32zM24.1 26.29h-.86a3.19 3.19 0 01-3.14-3.19v-4.69a1.24 1.24 0 00-1.23-1.23H16.5a1 1 0 010-2h2.36a3.23 3.23 0 013.24 3.23v4.69a1.19 1.19 0 001.19 1.19h.81a1.19 1.19 0 001.23-1.19V9.31a1 1 0 112 0V23.1a3.19 3.19 0 01-3.23 3.19z"
                />
                <path
                    strokeWidth={0}
                    // eslint-disable-next-line
                    d="M28.89 9.79h-5.11a2.13 2.13 0 01-2.13-2.14V4.84a2.13 2.13 0 012.13-2.14h5.11a2.14 2.14 0 012.13 2.14v2.81a2.14 2.14 0 01-2.13 2.14zM23.78 4.7a.13.13 0 00-.13.14v2.81a.13.13 0 00.13.14h5.11a.13.13 0 00.13-.14V4.84a.13.13 0 00-.13-.14z"
                />
                <path strokeWidth={0} d="M24.79 4.7a1 1 0 01-1-1V1a1 1 0 112 0v2.7a1 1 0 01-1 1zM27.88 4.7a1 1 0 01-1-1V1a1 1 0 112 0v2.7a1 1 0 01-1 1z" />
            </g>
        </svg>
    </Icon>
);

export default ChargingPoint;
